import type { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { addEditedField } from '../../../../../app/sliceUtils';
import type { NoteView } from '../../index';
import type { VerificationSliceState } from '../state';

/**
 * Notes tab reducers (spec 020). Notes round-trip on the SAVE view; these synchronous reducers mutate
 * the working case's note list and mark the page dirty. `noteId` is client-generated on add (FR-013);
 * the backend back-fills any id-less note (FR-012).
 */

/** Append a new note (FR-005). The caller stamps `noteId` / `changeBy` / `changeDate`. */
export const addNote: CaseReducer<VerificationSliceState, PayloadAction<NoteView>> = (state, action) => {
  if (!state.current) return;
  state.current.notes = [...(state.current.notes ?? []), action.payload];
  addEditedField(state, 'notes');
};

/** Edit a note's text (FR-008): keep `changeBy`, bump `changeDate` to now. Targets by `noteId`. */
export const updateNote: CaseReducer<
  VerificationSliceState,
  PayloadAction<{ noteId: string; noteText: string }>
> = (state, action) => {
  if (!state.current) return;
  const { noteId, noteText } = action.payload;
  state.current.notes = (state.current.notes ?? []).map((n) =>
    n.noteId === noteId ? { ...n, noteText, changeDate: new Date().toISOString() } : n,
  );
  addEditedField(state, 'notes');
};

/** Remove a note by `noteId` (FR-009). */
export const removeNote: CaseReducer<VerificationSliceState, PayloadAction<string>> = (state, action) => {
  if (!state.current) return;
  state.current.notes = (state.current.notes ?? []).filter((n) => n.noteId !== action.payload);
  addEditedField(state, 'notes');
};
